import React from 'react';

export const OHIFLogoColorDarkBackground = () => (
  <img src="https://obz.ai/logo/obzai-logo-dark.png" width="200px" alt="OBZ.ai Logo" />

);

export default OHIFLogoColorDarkBackground;
